import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
// Montserrat font - self-hosted for faster loading
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import './index.css';
import './utils/console-helpers'; // Add console helpers for development
// import { HelmetProvider } from 'react-helmet-async'; // Disabled - causing ref warnings

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
